import { render } from "./UserGroupMessageDialog.vue?vue&type=template&id=1724769c"
import script from "./UserGroupMessageDialog.vue?vue&type=script&lang=js"
export * from "./UserGroupMessageDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__